export const addClass = (className, element) => {
    element.classList.add(className);
};
export const removeClass = (className, element) => {
    element.classList.remove(className);
};
export const hasClass = (className, element) => {
    if (element instanceof HTMLElement) {
        return element.classList.contains(className);
    }
};
